<app-inner-box>
  <app-subpage-header title="Exporte"></app-subpage-header>
  <app-export-list-view #exportListViewComponentRef></app-export-list-view>
</app-inner-box>
